import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { TextField, Button, Box, Typography, Container } from "@mui/material";
import { toast } from "react-toastify"; // Import toast
import "react-toastify/dist/ReactToastify.css"; // Import the toastify CSS
import apiClient from "../components/apiClient";
import { location, useLocation } from "react-router-dom";
import { useCart } from "../components/CartContext";

const Register = () => {
  const [nama, setNama] = useState("");
  const [email, setEmail] = useState("");
  const [telepon, setTelepon] = useState("");
  const lokasi = "sby"; // Default lokasi to "sby"
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [tgl_lahir, setTanggalLahir] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();
  const [ipAddress, setIpAddress] = useState("");

  const location = useLocation();
  const { setIsLoggedIn, fetchCartCount, clearCart } = useCart();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    console.log("Navigation changed:", location.pathname);
  }, [location.pathname]);

  useEffect(() => {
    fetch("https://api.ipify.org?format=json")
      .then((response) => response.json())
      .then((data) => {
        setIpAddress(data.ip);
        console.log("IP Address:", data.ip);
      })
      .catch((error) => {
        console.error("Error fetching IP address:", error);
      });
  }, []);

  const handleRegister = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");
    setErrorMessage("");
    setLoading(true);

    if (!email) {
      setError("Please enter your email.");
      setLoading(false);
      return;
    }

    if (password !== confirmPassword) {
      setErrorMessage("Password dan konfirmasi password tidak cocok.");
      setLoading(false);
      return;
    }

    const isValidPhoneNumber = /^[0-9]{10,15}$/.test(telepon);
    if (!isValidPhoneNumber) {
      setErrorMessage("Nomor telepon tidak valid. Masukkan 10-15 angka.");
      setLoading(false);
      return;
    }

    try {
      // ✅ Step 1: Send OTP first (no user creation yet)
      const otpResponse = await apiClient.post("/user/send-otp", { email, lokasi });

      if (otpResponse.data.success) {
        setMessage(
          "Otp has been sent successfully to your email. Please check your inbox."
        );

        // ✅ Step 2: Store form data for later registration
        localStorage.setItem(
          "pendingRegisterData",
          JSON.stringify({ nama, tgl_lahir, email, password, telepon, lokasi })
        );

        setTimeout(() => {
          navigate("/verify-otp", { state: { email } });
        }, 3000);
      } else {
        setErrorMessage(
          otpResponse.data.message || "Gagal mengirim email OTP."
        );
      }
    } catch (error) {
      console.error("Register error:", error);
      if (error.response?.data?.message) {
        setErrorMessage("Terjadi kesalahan: " + error.response.data.message);
      } else if (error.request) {
        setErrorMessage("Tidak ada respons dari server. Coba lagi.");
      } else {
        setErrorMessage("Terjadi kesalahan saat mengirim OTP.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 px-4">
      <div className="mt-16 w-full max-w-2xl bg-white rounded-lg shadow-lg p-8 space-y-6">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-900">
          Sign Up
        </h2>

        {/* <p className="text-base md:text-lg text-center text-gray-600">
          Enter your email address to log in or create an account.
        </p> */}

        {errorMessage && (
          <p className="text-red-500 text-center text-sm">{errorMessage}</p>
        )}

        {message && (
          <p className="text-green-600 text-center text-sm">{message}</p>
        )}
        {error && <p className="text-red-500 text-center text-sm">{error}</p>}

        <form
          // onSubmit={(e) => {
          //   e.preventDefault();
          //   handleRegister();
          // }}
          onSubmit={handleRegister}
          className="space-y-4"
        >
          {/* Nama */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Nama
            </label>
            <input
              type="text"
              value={nama}
              onChange={(e) => setNama(e.target.value)}
              required
              className="w-full px-4 py-3 bg-gray-200 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
              placeholder="Nama lengkap"
            />
          </div>

          {/* Email */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full px-4 py-3 bg-gray-200 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
              placeholder="you@example.com"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Tanggal Lahir
            </label>
            <input
              type="date"
              value={tgl_lahir}
              onChange={(e) => setTanggalLahir(e.target.value)}
              required
              className="w-full px-4 py-3 bg-gray-200 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
              placeholder="YYYY-MM-DD"
            />
          </div>

          {/* Telepon */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Telepon
            </label>
            <input
              type="text"
              value={telepon}
              onChange={(e) => setTelepon(e.target.value)}
              required
              className="w-full px-4 py-3 bg-gray-200 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
              placeholder="0812xxxxxxx"
            />
          </div>

          {/* Password */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full px-4 py-3 bg-gray-200 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
              placeholder="••••••••"
            />
          </div>

          {/* Confirm Password */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Confirm Password
            </label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              className="w-full px-4 py-3 bg-gray-200 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
              placeholder="••••••••"
            />
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            disabled={loading}
            className={`w-full py-3 text-lg font-semibold rounded-md transition duration-300 ${
              loading
                ? "bg-gray-500 cursor-not-allowed text-white"
                : "bg-black text-white hover:bg-gray-800"
            }`}
          >
            {loading ? "Registering..." : "REGISTER"}
          </button>

          {/* <button 
            className="w-full py-3 bg-black text-white text-lg font-semibold rounded-md hover:bg-gray-800 transition duration-300"
          onClick={() => navigate("/verify-otp", { state: { email } })}>
  Go to OTP page
</button> */}
        </form>
      </div>
    </div>
  );
};

export default Register;
